import React from 'react';
import {Router, Route, Redirect, IndexRedirect, browserHistory} from 'react-router';
import AuthView from './../views/AuthView/AuthView.jsx';
import LoginForm from './../auth/LoginForm/LoginForm.jsx';

export default () => {
  return (
    <Router history={ browserHistory }>
      <Route component={ AuthView } path="/auth">
        <IndexRedirect to="login" />
        <Route component={ LoginForm } path="login" />
      </Route>
      <Redirect from='*' to="/auth" />
    </Router>
  );
};


/** WEBPACK FOOTER **
 ** ./src/js/routes/Public.jsx
 **/